var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnhappyIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_45384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4253 12.6195C14.6235 13.0777 14.4126 13.6097 13.9547 13.8074C13.4965 14.0062 12.9647 13.795 12.7665 13.3368C11.8949 11.3216 9.83514 10.0192 7.51807 10.0192C5.14768 10.0192 3.07525 11.3207 2.23892 13.3344C2.09431 13.682 1.7578 13.8917 1.4038 13.8917C1.28812 13.8917 1.17092 13.8697 1.05734 13.8227C0.596402 13.6308 0.377982 13.1018 0.569288 12.6411C1.687 9.9502 4.41469 8.21158 7.51777 8.21158C10.5561 8.21218 13.2675 9.94207 14.4253 12.6195ZM1.2366 1.97559C1.2366 0.944349 2.07323 0.107422 3.10477 0.107422C4.13602 0.107422 4.97264 0.944048 4.97264 1.97559C4.97264 3.00774 4.13602 3.84437 3.10477 3.84437C2.07323 3.84407 1.2366 3.00744 1.2366 1.97559ZM9.7074 1.97559C9.7074 0.944349 10.5446 0.107422 11.5762 0.107422C12.6074 0.107422 13.444 0.944048 13.444 1.97559C13.444 3.00774 12.6077 3.84437 11.5762 3.84437C10.5446 3.84437 9.7074 3.00744 9.7074 1.97559Z",
    fill: "#EBEBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_45384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhappyIconDark);
export default __webpack_public_path__ + "static/media/UnhappyIconDark.a1fd716f95e4735a1243e87535b35465.svg";
export { ForwardRef as ReactComponent };